import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[fallbackImage]'
})
export class FallbackImageDirective {
  @Input() fallbackImage = 'assets/images/profile/user-1.jpg';

  @HostListener('error', ['$event.target'])
  onError(target: HTMLImageElement) {
    target.src = this.fallbackImage;
  }
}
